export default __webpack_public_path__ + "static/airbnb-mobile-3cc31329b54baf227b3fcc7706b108d9.jpg";